<template>

    <div>
        <v-container fluid class="pa-0">
            <v-row dense>

                <!-- Total imported counter -->
                <v-col cols="12" sm="6" md="3" lg="3">
                    <stat-box-text hint="Current status" :color="statusColor"
                                   :value="statusMessage">
                    </stat-box-text>
                </v-col>

                <!-- Total imported counter -->
                <v-col cols="12" sm="6" md="3" lg="3">
                    <stat-box-numerical hint="# imported" color="green"
                                        :value="totalImported">
                    </stat-box-numerical>
                </v-col>

                <!-- ERRORS COUNTER -->
                <v-col cols="12" sm="6" md="3" lg="3">
                    <v-scale-transition>
                        <stat-box-numerical v-show="totalErrors > 0" hint="# of errors" color="error"
                                            :value="totalErrors">
                        </stat-box-numerical>
                    </v-scale-transition>
                </v-col>

                <!-- ACTION BUTTONS -->
                <v-col cols="12" sm="6" md="3" lg="3" class="text-right">
                    <v-btn v-show="lineErrors.length > 0"
                           :color="status==='progress' ? 'secondary' : 'primary'"
                           @click="goToDownloadsClicked">Downloads
                    </v-btn>
                </v-col>
            </v-row>
        </v-container>

        <v-alert type="warning" icon="mdi-alert" class="mt-2 mb-2 body-2">
            Here is a snapshot of the errors. A complete error report will be found in the Downloads.
        </v-alert>

        <!-- CSV Imported line errors -->
        <div ref="scrollContainerWrapper"
             class="scroll-container-wrapper"
             style="background-color: white;"
             v-show="lineErrors.length > 0">

            <v-scale-transition group>
                <v-sheet color="white" key="header">
                    <error-line :header="true" :ignored="ignoredColumns" :error="headers"></error-line>
                </v-sheet>

                <v-sheet color="white" v-for="(lineError, index) in orderedLineErrors" :key="index">
                    <error-line :ignored="ignoredColumns" :error="lineError"></error-line>
                </v-sheet>
            </v-scale-transition>

        </div>
    </div>

</template>

<script>

import Json from 'vue-json-pretty';
import ErrorLine from "../../../components/UI/ErrorLine";
import {mapState, mapGetters} from 'vuex';
import StatBoxNumerical from "../../../components/UI/StatBoxNumerical";
import StatBoxText from "../../../components/UI/StatBoxText";

const vuexModule = 'PanelistImporter';

export default {

    components: {
        ErrorLine,
        StatBoxNumerical,
        StatBoxText,
        Json
    },

    props: {},

    data() {
        return {
            debug: false,
            totalErrors: 0,
            totalImported: 0,
            lineErrors: [],
            status: null,
        }
    },

    computed: {
        ...mapState(vuexModule, [
            'mappings',
        ]),

        ...mapGetters(vuexModule, [
            'ignoredColumns',
        ]),

        orderedLineErrors() {
            return this.lineErrors.sort((first, second) => {
                if (first.line < second.line) return -1;
                if (first.line > second.line) return 1;
                return 0;
            });
        },

        statusMessage() {
            if (this.status) return this.ucFirst(this.status);
            return "Preparing...";
        },

        statusColor() {
            if (!this.status) return 'primary';
            if (this.status === 'complete') return 'success';
            if (this.status === 'aborted') return 'error';
            if (this.status === 'running') return 'primary';
        },

        headers() {
            if (this.mappings) {

                const record = this.mappings.map(mapping => {
                    let columnName = mapping.column.name;
                    if (mapping.column.optionName) columnName += ":" + mapping.column.optionName;
                    return columnName;
                }).join(',');

                return {
                    line: 1,
                    lineError: 'CSV file headers',
                    data: record,
                    columnErrors: null,
                };
            }
        },

        ignoredColumns() {
            return this.mappings.filter(mapping => mapping.column.userActions.ignore === true)
                .map(mapping => mapping.column.index);
        }
    },

    mounted() {

        Bus.$on('live-progress', (notification) => {

            this.status = notification.status;

            if (notification.status === 'aborted') {
                Bus.$emit('flash-message', {type: 'error', message: notification.message});
                return;
            }

            if (notification.processedCount) {
                this.totalImported = notification.processedCount;
            }

            if (notification.errorCount) {
                this.totalErrors = notification.errorCount;
            }
        });

        Bus.$on('live-error', (notification) => {
            this.lineErrors = [...notification.errors, ...this.lineErrors];
        });

        this.$refs.scrollContainerWrapper.scroll = () => {
            console.log(this.$refs.scrollContainerWrapper.scrollLeft);
        }
    },

    methods: {

        backToUploaderClicked() {
            this.resetComponent();
            this.$emit('back');
        },

        newImportClicked() {
            this.resetComponent();
            this.$emit('reset')
        },

        goToDownloadsClicked() {
            this.$router.push('/spa/downloads');
        },

        resetComponent() {
            this.totalErrors = 0;
            this.totalImported = 0;
            this.lineErrors = [];
            this.status = null;
        },
    }
}
</script>

<style scoped>

.scroll-container-wrapper {
    overflow-x: scroll;
    white-space: nowrap;
}

.scroll-bar-wrapper {
    overflow-x: scroll;
    overflow-y: hidden;
}

.scroll-bar {
    width: 2000px;
    height: 40px;
}

</style>